// extracted by mini-css-extract-plugin
export var subtitle = "_9h-2";
export var title = "_9h-0";
export var titleNoWrap = "_9h-1";